var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',[_vm._v("Test Map")]),_c('v-row',[_c('google-map',{ref:"map",staticStyle:{"width":"100%","height":"600px"},attrs:{"center":{ lat: 0, lng: 0},"zoom":1}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }